import vesselProtocol from "../services/vessel-protocol";

export default {
    TEST_LINK: 'http://10.3.100.47:30997/',


    DATE_FORMAT: 'dd/mm/yy',
    DATE_FORMAT_POINT: 'dd/mm/yy',
    DATETIME_FORMAT: 'dd/mm/yy hh:ii:ss',
    DATETIME_FORMAT_POINT: 'dd/mm/yy hh:ii:ss',

    DATE_PLACEHOLDER_POINT: 'DD/MM/YYYY hh:mm',
    DATE_PLACEHOLDER_POINT_ONLY_DATE: 'DD/MM/YYYY',

    MAX_5_4: 9.9999,
    MAX_6_4: 99.9999,
    MAX_10_3: 9999999.999,
    MAX_18_3: 999999999999999.999,
    MAX_18: 999999999999999999,
    MAX_18_4: 999999999999.9999,
    MAX_18_5: 999999999999.99999,
    MAX_18_6: 999999999999.999999,

    transportType: {
        SHIP: 'N',
        TANKER: 'T',
        PIPE: 'P',
        STOCK_TRANSFER: 'S',
        BARGE: 'B'
    },

    chargeDischarge: {
        CHARGE: 'C',
        DISCHARGE: 'D'
    },
    movementDirection: {
        IN: 'IN',
        OUT: 'OUT'
    },

    tankManagement: {
        EMPTY_FILE_NAME: 'Tank_Template.xlsx',
        FILLED_FILE_NAME: (tankCode) => `Tank_Template_${tankCode}.xlsx`
    },

    movementInstructionStatuses: [
        {code: "CREATED"},
        {code: "ONGOING"},
        {code: "CANCELED"},
        {code: "CLOSED"}
    ],

    pipeTransferFlags: [
        {label: 'pipeTypeC', id: 'C'},
        {label: 'pipeTypeP', id: 'P'}
    ],

    getPipeTransferLabel: function(t){
        return 'movementInstructions.pipeType' + t;
    },

    defaultPlantId: 2,

    vesselProtocolReports: {
        customsOffice: 'Ufficio delle Dogane di Siracusa',
        atrCustomsOffice: 'Siracusa',
        comunicationPlace: 'Priolo G.',
        signer: 'ISAB s.r.l.',
        company: 'ISAB S.r.l.',
        companyAddress: 'EX S.S. 114, KM 146 - 96010 PRIOLO G. (SR)',
        taxCodeOrVatNumber: '01629050897',
        consignorTrader: 'ISAB S.r.l. per TRAFIGURA PTE LTD',
        consignorTraderAddress: '10 COLLYER QUAY # 29-01/05 OCEAN FINANCIAL\nCENTRE, 049315 SINGAPORE',
        clientCompany: 'VERSALIS S.P.A.',
        originCountryType: 'Unione Europea',
        exporterNameInf3: 'ISAB S.R.L.',
        exporterAddressInf3: 'S.S. 114, Km 146 - 96010 Priolo G. (SR)',
        exporterNameInf4: 'ISAB SRL',
        exporterAddressInf4: 'EX SS 114 KM 146 - 96010 PRIOLO G. - ITALIA',
        declarationPlace: 'Priolo G. (SR) Italy',
        trafiguraName: 'TRAFIGURA PTE. LTD.',
        trafiguraAddress: '10 COLLYER QUAY #29-00 OCEAN FINANCIAL CENTRE',
        isabName: 'ISAB S.R.L.',
        isabAddress: 'S.S. 114, Km 146 - 96010 Priolo G. (SR)',
        isabVatNumber: '01629050897',
        consigneeTrader53: 'Amministrazione ISAB s.r.l.\nc.a. Scicolone G./Vaccaro M.',
        originPlaceXAB: 'PRIOLO SERVIZI Scpa\nC/o RAFFINERIA ISAB IMPIANTI NORD',
        companyXAB: 'ISAB S.R.L.\nex ss 114 Litoranea Priolese\n96010 - Priolo G. (SR)'
    }
}